import React,{useState,useEffect} from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

// Reuse your existing DashboardCard component:
import DashboardCard from "../../../../components/Cards/DashboardCard";
import back from "../../../../assets/back.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import TasksTable from "./TasksTable";
import TaskDetails from "./TaskDetails";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import CalendarView from "./TaskCalender.js";
import { useLocation,useNavigate } from "react-router-dom";
import MapTask from "./MapTasks.js";
import { useSelector } from "react-redux";



import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ScheduleIcon from "@mui/icons-material/Schedule";
import StopIcon from "@mui/icons-material/Stop";
import ErrorIcon from "@mui/icons-material/Error";
import CancelIcon from "@mui/icons-material/Cancel";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RemoveIcon from "@mui/icons-material/Remove";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HelpIcon from "@mui/icons-material/Help";

const MyTasks = () => {
  const { t } = useTranslation();
  const [selectedTask, setSelectedTask] = useState(null);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
   const fromCards = location.state?.fromCards;
  const [stats, setStats] = useState({
    assigned: 0,
    inProgress: 0,
    completed: 0,
    delayed: 0,
    notDone: 0,
    cancelled: 0,
  });

const reduxEncryptedToken = useSelector((state) => state.auth.token);
const localEncryptedToken = localStorage.getItem("token");
const token = reduxEncryptedToken
  ? decryptToken(reduxEncryptedToken)
  : localEncryptedToken
  ? decryptToken(localEncryptedToken)
  : null;
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [selectedMapTaskId, setSelectedMapTaskId] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({
    status: "",
    startDate: "",
    endDate: "",
  });
  const [taskDetails, setTaskDetails] = useState(null);
   const fetchTaskDetails = async (id) => {
    try {
      if (!token) {
        console.error("❌ Missing auth token while fetching task details");
        return;
      }
      const endpoint = `${BASE_URL}/task-management/worker/tasks/${id}`;
      const res = await fetch(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      const payload = data?.data ?? null;
      const taskNode = payload?.task ?? null;

      if (!data?.error && taskNode) {
        console.log("✅ Task details API:", endpoint, taskNode);
        setTaskDetails({
          ...taskNode,
          assignments: payload?.assignments || [],
          comments: payload?.comments || [],
          events: payload?.my_events || payload?.events || [],
          timing: payload?.timing || null,
          validation: payload?.validation || null,
        });
        return;
      }

      console.error("❌ Task details request failed:", {
        status: res.status,
        statusText: res.statusText,
        message: data?.message || "Unknown error",
        endpoint,
      });
    } catch (err) {
      console.error("❌ Error fetching task details:", err);
    }
  };
  


   useEffect(() => {
    const fetchCounters = async () => {
      try {
        const res = await fetch(`${BASE_URL}/task-management/worker/tasks/counters`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        console.log("✅ Counters API:", data);

        if (!data.error) {
          const c = data.data.counters;
          setStats({
  all_tasks: c.all_tasks ?? 0,
  completed_tasks: c.completed_tasks ?? 0,
  not_completed_tasks: c.not_completed_tasks ?? 0,
  start_task_today: c.start_task_today ?? 0,
  on_time_start_task_today: c.on_time_start_task_today ?? 0,
  late_start_task_today: c.late_start_task_today ?? 0,
  end_task_today: c.end_task_today ?? 0,
  on_time_end_task_today: c.on_time_end_task_today ?? 0,
  late_end_task_today: c.late_end_task_today ?? 0,
  not_done_until_today: c.not_done_until_today ?? 0,
  cancelled_until_today: c.cancelled_until_today ?? 0,
  priority_urgent_today: c.priority_urgent_today ?? 0,
  priority_high_today: c.priority_high_today ?? 0,
  priority_medium_today: c.priority_medium_today ?? 0,
  priority_low_today: c.priority_low_today ?? 0,
  not_validated_events: c.not_validated_events ?? 0
});
        }
      } catch (err) {
        console.error("❌ Error fetching counters:", err);
      }
    };

    if (token) fetchCounters();
  }, [token]);




  const handleSelectTaskOnMap = (id) => {
  setSelectedMapTaskId(id);
    setSelectedCalendarTaskId(id);   // ✅ ADD THIS

};

// 👉 ONLY for DETAILS 
const handleOpenTaskDetails = (id) => {
  setSelectedTaskId(id);
  setSelectedCalendarTaskId(id);   // ✅ ADD THIS LINE
  fetchTaskDetails(id);

  const scrollContainer = document.querySelector("#root");
  if (scrollContainer) {
    scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

// const handleOpenTaskDetails = (id) => {
//   setSelectedTaskId(id);
//   fetchTaskDetails(id);

//   const scrollContainer = document.querySelector("#root");
//   if (scrollContainer) {
//     scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
//   } else {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }
// };

  const handleBack = () => {
    setSelectedTaskId(null);
    setTaskDetails(null);
  };

  useEffect(() => {
  if (location.state?.scrollTo) {
    const el = document.getElementById(location.state.scrollTo);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
    }
  }
}, [location]);
const [selectedCalendarTaskId, setSelectedCalendarTaskId] = useState(null);
  return (
    <>

                 {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1,
   
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('worker')} 
      </CustomText>
    </Box>
  </Box>
)}
    <Box sx={{px:1}}>
     
             {selectedTaskId ? (
      <TaskDetails
        task={taskDetails}
        onBack={handleBack}
        refreshTaskDetails={fetchTaskDetails}
      />
        ) : (
          <>
    <Box
        sx={{
          display: "grid",
          gap: 1,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(5, 1fr)",
          },
        }}
    >
    <DashboardCard
  MaterialIcon={AssignmentIcon}
  iconBgColor="#579DFF"
  title={t("taskscards.allTasks")}
  description={stats.all_tasks}
/>

<DashboardCard
  MaterialIcon={CheckCircleIcon}
  iconBgColor="#4BCE97"
  title={t("taskscards.completedTasks")}
  description={stats.completed_tasks}
/>

<DashboardCard
  MaterialIcon={HourglassEmptyIcon}
  iconBgColor="#F87168"
  title={t("taskscards.notCompletedTasks")}
  description={stats.not_completed_tasks}
/>

<DashboardCard
  MaterialIcon={PlayArrowIcon}
  iconBgColor="#9F8FEF"
  title={t("taskscards.start")}
  description={stats.start_task_today}
/>

<DashboardCard
  MaterialIcon={CheckCircleIcon}
  iconBgColor="#4BCE97"
  title={t("taskscards.startOnTimeToday")}
  description={stats.on_time_start_task_today}
/>

<DashboardCard
  MaterialIcon={ScheduleIcon}
  iconBgColor="#F87168"
  title={t("taskscards.startLate")}
  description={stats.late_start_task_today}
/>

<DashboardCard
  MaterialIcon={StopIcon}
  iconBgColor="#9F8FEF"
  title={t("taskscards.end")}
  description={stats.end_task_today}
/>

<DashboardCard
  MaterialIcon={CheckCircleIcon}
  iconBgColor="#4BCE97"
  title={t("taskscards.endOnTime")}
  description={stats.on_time_end_task_today}
/>

<DashboardCard
  MaterialIcon={ScheduleIcon}
  iconBgColor="#F87168"
  title={t("taskscards.endLate")}
  description={stats.late_end_task_today}
/>

<DashboardCard
  MaterialIcon={ErrorIcon}
  iconBgColor="#FEA362"
  title={t("taskscards.notDone")}
  description={stats.not_done_until_today}
/>

<DashboardCard
  MaterialIcon={CancelIcon}
  iconBgColor="#579DFF"
  title={t("taskscards.cancelled")}
  description={stats.cancelled_until_today}
/>

<DashboardCard
  MaterialIcon={KeyboardArrowUpIcon}
  iconBgColor="#F5CD47"
  title={t("taskscards.priorityHigh")}
  description={stats.priority_high_today}
/>

<DashboardCard
  MaterialIcon={RemoveIcon}
  iconBgColor="#579DFF"
  title={t("taskscards.priorityMedium")}
  description={stats.priority_medium_today}
/>

<DashboardCard
  MaterialIcon={KeyboardArrowDownIcon}
  iconBgColor="#4BCE97"
  title={t("taskscards.priorityLow")}
  description={stats.priority_low_today}
/>

<DashboardCard
  MaterialIcon={HelpIcon}
  iconBgColor="#FEA362"
  title={t("taskscards.unvalidated")}
  description={stats.not_validated_events}
/>

    </Box>
    <Box sx={{mt:1}}>
        {/* <CalendarView onSelectTask={handleSelectTask}/> */}
        {/* <CalendarView  onSelectTask={handleOpenTaskDetails} />
         */}
         <CalendarView
  selectedTaskId={selectedCalendarTaskId}
  onClearFilter={() => setSelectedCalendarTaskId(null)}
  onSelectTask={handleOpenTaskDetails}
  appliedFilters={appliedFilters}
/>
    </Box>
      <Box sx={{mt:2, mb:1}}>
            {/* <MapTask
            //  onSelectTask={handleSelectTask}
              selectedTaskId={selectedTaskId}
  onClearSelection={() => setSelectedTaskId(null)}
  onSelectTask={handleSelectTask}
             /> */}
             <MapTask
  selectedTaskId={selectedMapTaskId}
  onClearSelection={() => setSelectedMapTaskId(null)}
  onSelectTask={handleSelectTaskOnMap}
  appliedFilters={appliedFilters}
/>
          </Box>
    <Box id="tasks-table-section">
      {fromCards && (
    <Box
      sx={{
        border: '1px solid #E4E6EF',
        borderRadius: 2,
        px: 2,
        py: 1.5,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: 55,
        mb: 2,
      }}
    >
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
        onClick={() => navigate(-1)}
      >
        <img src={back} style={{ width: 30, height: 30 }} />
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 500,
            fontSize: '14px',
            color: '#626F86',
            textAlign: 'center'
          }}
        >
          {t('worker')}
        </CustomText>
      </Box>
    </Box>
  )}
               {/* <TasksTable onSelectTask={handleSelectTask} /> */}
               <TasksTable
  onRowClick={handleSelectTaskOnMap}      // map pin only
  onViewDetails={handleOpenTaskDetails}   // details screen
  onFiltersApplied={setAppliedFilters}
/>

    </Box>
    </>
       )}
    </Box>
    </>
  );
};

export default MyTasks;
